import React from 'react'
import ReactFitText from 'react-fittext'
import bigMac from '../../../assets/images/big_mac.jpg'
import co2 from '../../../assets/images/co2.jpg'
import calories from '../../../assets/images/world.jpg'
import './StatisticsCard.scss'
import { useOsScale } from '../../../common/helpers/useOsScale'

export interface ICaloriesCardProps {
  value?: string
  pretext?: string
  valuetext?: string
  posttext?: string
  text?: string
  type: 'calories' | 'intensiveMinutes' | 'steps'
}

const getIllustration = (type: ICaloriesCardProps['type']) => {
  switch (type) {
    case 'calories':
      return bigMac
    case 'intensiveMinutes':
      return co2
    case 'steps':
      return calories
    default:
      return undefined
  }
}

export function StatisticsCard(props: ICaloriesCardProps) {
  const { type } = props
  // ReactFitText takes maxFontSize in raw pixels (it sets inline font-size in
  // px), so CSS rem can't help — multiply the cap by --os-scale so the text
  // grows when iOS Dynamic Type is enlarged.
  const osScale = useOsScale()
  const pretextMax = 16 * osScale
  const valueMax = 24 * osScale

  let { pretext, posttext, value, valuetext, text } = props

  if (text) {
    const parts = text.split('<b>')
    if (parts.length > 1) {
      const parts2 = parts[1].split('</b>')
      if (parts2.length > 1) {
        pretext = parts[0]
        text = parts2[0]
        posttext = parts2[1]

        const parts3 = text.split(' (')
        if (parts3[1]) {
          value = parts3[0]
          valuetext = '(' + parts3[1]
        }
      }
    }
  }

  return (
    <div className={`statistics-card statistics-card--${type}`}>
      <img
        className={`statistics-card__illustration statistics-card__illustration--${type}`}
        src={getIllustration(type)}
        alt=""
        aria-hidden="true"
      />
      <div className={`statistics-card__content statistics-card__content--${type}`}>
        <ReactFitText maxFontSize={pretextMax}>
          <p className="statistics-card__pretext">{pretext}</p>
        </ReactFitText>

        <ReactFitText compressor={0.5} maxFontSize={valueMax}>
          {value && valuetext ? (
            <p className="statistics-card__value">
              {value} <span className="statistics-card__nowrap">{valuetext}</span>
            </p>
          ) : (
            <p className="statistics-card__value xstatistics-card__nowrap">{text}</p>
          )}
        </ReactFitText>

        <ReactFitText maxFontSize={pretextMax}>
          <p className="statistics-card__posttext">{posttext}</p>
        </ReactFitText>
      </div>
    </div>
  )
}
